// @ts-strict-ignore
export function useDebounceFn<T>(
  func: (...args: any[]) => T,
  duration = 500,
): (...args: any[]) => void {
  let timeout: any | null = null

  return function (...args: any[]): void {
    const effect = (): T => {
      timeout = null
      return func.apply(this, args)
    }

    clearTimeout(timeout)
    timeout = setTimeout(effect, duration)
  }
}
